import styles from './styles/hero.module.css';

const Hero = () => {
  
  return (
    <section className={styles.hero}>
      <div className={styles.heroOverlay}>
        <div className={styles.heroContent}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/homepage/icon.png" alt="1 Stop Kitchens & Countertops" className={styles.heroBg} />
          <img src="https://ik.imagekit.io/1stopkitchens/images/homepage/background1.png" style={{display: 'none'}} alt="preload" loading="eager" /> {/* Added for preload */}
          <h1>1 Stop Kitchens & Countertops</h1>
          <p>
            It only takes One Stop to find the Service, Quality and Products to make your dream kitchen into a reality.
            <br/>
            <i>Est. 1995</i>
          </p>
        </div>
      </div>
    </section>
  );
}
export default Hero